<template>
    <b-form-group label-for="state">
        <template slot="label"
            >{{ $t("pages.forms.common.state")
            }}<span v-if="required" class="font-weight-bolder text-danger"
                >*</span
            ></template
        >
        <validation-provider
            :rules="{ required }"
            v-slot="{ dirty, validated, valid, errors }"
        >
            <b-input-group v-show="!isReviewing">
                <b-form-input
                    id="state"
                    v-model="state"
                    :state="dirty || validated ? valid : null"
                    type="text"
                    :required="required"
                    @input="update"
                />
                <b-form-invalid-feedback
                    :state="dirty || validated ? valid : null"
                    >{{ errors[0] }}</b-form-invalid-feedback
                >
            </b-input-group>
        </validation-provider>
        <b-form-input
            type="text"
            :value="state"
            readonly
            plaintext
            v-show="isReviewing"
        />
    </b-form-group>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
    components: { ValidationProvider },
    data() {
        return {
            state: this.value
        };
    },
    props: {
        value: null,
        required: {
            type: Boolean,
            default: false
        },
        reviewing: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update(value) {
            this.$emit("input", value);
        }
    },
    computed: {
        isReviewing() {
            return this.reviewing;
        }
    }
};
</script>
